/* eslint-disable import/no-unused-modules */
/**
 * This file contains storage slot constants used for various proxy patterns in Ethereum.
 * Each slot is a 32-byte value that stores implementation addresses in proxy contracts.
 */

// EIP-1967: Storage slot for implementation contract address
// Used in UUPS pattern for upgradeable contracts
// Ref: https://eips.ethereum.org/EIPS/eip-1967#logic-contract-address
export const EIP1967_SLOT =
  "0x360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc"

// EIP-1822: Alternative UUPS implementation slot
// Used in Universal Upgradeable Proxy Standard (UUPS)
// Ref: https://eips.ethereum.org/EIPS/eip-1822
export const UUPS_SLOT =
  "0xc5f16f0fcc639fa48a6947836d9850f504798523bf8c9a3a87d5876cf622bcf7"

// OpenZeppelin's Transparent Proxy Pattern
// Separates admin and user interfaces to prevent function clashing
// Ref: https://docs.openzeppelin.com/contracts/4.x/api/proxy#TransparentUpgradeableProxy
export const TRANSPARENT_PROXY_SLOT =
  "0x7050c9e0f4ca769c69bd3a8ef740bc37934f8e2c036e5a723fd8ee048ed3f8c3"

// Beacon Proxy Pattern: Implementation controlled by central beacon
// Allows multiple proxies to be upgraded atomically
// Ref: https://eips.ethereum.org/EIPS/eip-1967#beacon-contract-address
export const BEACON_PROXY_SLOT =
  "0xa3f0ad74e5423aebfd80d3ef4346578335a9a72aeaee59ff6cb3582b35133d50"

// Standard Proxy Pattern: Basic proxy implementation
// Simple delegation pattern for contract upgrades
// Ref: https://docs.openzeppelin.com/contracts/4.x/api/proxy#Proxy
export const STANDARD_PROXY_SLOT =
  "0x8b78c6d8535e44ef6e3d1f340c3db6a4a8a5772d9e4e3da0f0cc38fb5a8b0e0c"

// Diamond Storage Pattern: Multi-facet proxy pattern
// Supports multiple implementation contracts (facets)
// Ref: https://eips.ethereum.org/EIPS/eip-2535
export const DIAMOND_STORAGE_SLOT =
  "0xc8fcad8db84d3cc18b4c41d551ea0ee66dd599cde068d998e57d5e09332c131c"

// ZkSync Era Admin Proxy Pattern
// Used for proxy admin implementation in ZkSync Era
// The slot is calculated as: bytes32(uint256(keccak256('eip1967.proxy.admin')) - 1)
export const ZKSYNC_ERA_ADMIN_SLOT =
  "0xb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d6103"

// Array of all implementation slots for proxy pattern detection
export const IMPLEMENTATION_SLOTS = [
  EIP1967_SLOT,
  UUPS_SLOT,
  TRANSPARENT_PROXY_SLOT,
  BEACON_PROXY_SLOT,
  STANDARD_PROXY_SLOT,
  DIAMOND_STORAGE_SLOT,
  ZKSYNC_ERA_ADMIN_SLOT,
]
